import React from 'react';
import { Card } from 'antd';
import { Swiper, SwiperSlide } from 'swiper/react';
import { EffectCoverflow, Pagination, Autoplay } from 'swiper/modules';
import WrappedModal from '@/components/WrappedModal';
import 'swiper/css/autoplay';
import 'swiper/css';
import 'swiper/css/effect-coverflow';
import 'swiper/css/pagination';
import 'swiper/css/autoplay';
import '../Page.less';

// 轮播图容器样式配置
const CONTAINER_STYLES = {
  height: '100%',
  position: 'relative',
  borderRadius: '4px',
  overflow: 'hidden'
};




// 半透明遮罩层样式，用于增强文字可读性
const OVERLAY_STYLES = {
  position: 'absolute',              // 绝对定位，覆盖整个容器
  top: 0,                           // 顶部对齐
  left: 0,                          // 左侧对齐
  right: 0,                         // 右侧对齐
  bottom: 0,                        // 底部对齐
  // backgroundColor: 'rgba(0, 0, 0, 0.2)' // 黑色半透明遮罩，透明度20%
};

// Swiper组件容器样式，确保轮播图正确显示
const SWIPER_CONTAINER_STYLES = {
  position: 'relative',              // 相对定位
  zIndex: 1,                        // 层级设置，确保显示在最上层
  height: '100%'                     // 高度100%，填充父容器
};

// 单个轮播幻灯片样式配置
const SWIPER_SLIDE_STYLES = {
  width: '47%',                      // 调整为47%，确保两张图片完整显示
  height: '100%',                    // 高度100%，填充容器
  display: 'flex',                   // 弹性布局
  justifyContent: 'flex-end',        // 右对齐，让激活图片靠右
  padding: '0px',               // 无内边距
  transition: 'transform 0.3s ease'  // 添加平滑过渡效果
};

// 卡片容器样式，用于显示图片内容
const CARD_STYLES = {
  background: 'rgba(0, 212, 255, 0.04)',
  border: '1px solid rgba(0, 212, 255, 0.15)',
  borderRadius: '4px',
  height: '88%',
  width: '100%',
  display: 'flex',
  justifyContent: 'center',
  margin: '4px 0 0 0',
  position: 'relative',
  overflow: 'hidden',
  transition: 'all 0.3s ease'
};

// 图片显示样式配置
const IMAGE_STYLES = {
  maxWidth: '80%',                  // 最大宽度90%，不超过容器
  maxHeight: '100%',                // 最大高度100%，不超过容器
  height: 'auto',                    // 高度自适应，保持宽高比
  display: 'block',                   // 块级元素，用于居中
  margin: '6px auto',                   // 水平居中
  objectFit: 'contain',              // 图片完整显示，保持比例
  borderRadius: '8px'                // 圆角边框，8像素
};

// Swiper轮播组件配置参数
const SWIPER_CONFIG = {
  effect: 'coverflow',               // 使用coverflow效果
  grabCursor: true,                  // 鼠标悬停时显示抓手光标
  centeredSlides: false,             // 不居中显示，让激活图片靠右
  slidesPerView: 'auto',             // 自动计算显示数量，确保完整显示
  spaceBetween: 5,                   // 进一步减小间距
  coverflowEffect: {                 // coverflow效果配置
    rotate: 0,                       // 移除旋转效果
    stretch: 0,                      // 拉伸值设为0，保持原始大小
    depth: 0,                        // 移除深度效果
    modifier: 1,                     // 效果倍率
    slideShadows: false              // 禁用幻灯片阴影
  },
  // 响应式断点配置 - 基于SWIPER_SLIDE_STYLES的75%宽度进行适配
  breakpoints: {
    // 当屏幕宽度 >= 320px (手机竖屏)
    320: {
      spaceBetween: 3,
      coverflowEffect: {
        rotate: 0,
        stretch: 0,
        depth: 0,
        modifier: 1,
        slideShadows: false
      }
    },
    // 当屏幕宽度 >= 480px (大屏手机竖屏)
    480: {
      spaceBetween: 4,
      coverflowEffect: {
        rotate: 0,
        stretch: 0,
        depth: 0,
        modifier: 1,
        slideShadows: false
      }
    },
    // 当屏幕宽度 >= 640px (手机横屏/小平板)
    640: {
      spaceBetween: 5,
      coverflowEffect: {
        rotate: 0,
        stretch: 0,
        depth: 0,
        modifier: 1,
        slideShadows: false
      }
    },
    // 当屏幕宽度 >= 768px (平板竖屏)
    768: {
      spaceBetween: 6,
      coverflowEffect: {
        rotate: 0,
        stretch: 0,
        depth: 0,
        modifier: 1,
        slideShadows: false
      }
    },
    // 当屏幕宽度 >= 960px (平板横屏/小笔记本)
    960: {
      spaceBetween: 7,
      coverflowEffect: {
        rotate: 0,
        stretch: 0,
        depth: 0,
        modifier: 1,
        slideShadows: false
      }
    },
    // 当屏幕宽度 >= 1024px (笔记本/小桌面)
    1024: {
      spaceBetween: 8,
      coverflowEffect: {
        rotate: 0,
        stretch: 0,
        depth: 0,
        modifier: 1,
        slideShadows: false
      }
    },
    // 当屏幕宽度 >= 1280px (桌面)
    1280: {
      spaceBetween: 9,
      coverflowEffect: {
        rotate: 0,
        stretch: 0,
        depth: 0,
        modifier: 1,
        slideShadows: false
      }
    },
    // 当屏幕宽度 >= 1440px (大桌面)
    1440: {
      spaceBetween: 10,
      coverflowEffect: {
        rotate: 0,
        stretch: 0,
        depth: 0,
        modifier: 1,
        slideShadows: false
      }
    },
    // 当屏幕宽度 >= 1920px (超大桌面)
    1920: {
      spaceBetween: 12,
      coverflowEffect: {
        rotate: 0,
        stretch: 0,
        depth: 0,
        modifier: 1,
        slideShadows: false
      }
    }
  },
  pagination: {                      // 分页器配置
    el: '.swiper-pagination',        // 分页器容器选择器
    clickable: true,                 // 分页器可点击切换
    dynamicBullets: true,            // 动态分页点
    renderBullet: function (index, className) {
      return '<span class="' + className + '">' + (index + 1) + '</span>';
    }
  },
  // 自动轮播配置
  autoplay: {
    delay: 3000,                     // 轮播间隔时间，单位毫秒
    disableOnInteraction: false,     // 用户交互后不停止自动轮播
    pauseOnMouseEnter: false,        // 鼠标悬停时不暂停轮播
    stopOnLastSlide: false,          // 到最后一张继续循环，不停止
    reverseDirection: false,         // 不反向播放
    waitForTransition: true,         // 等待过渡动画完成
    enabled: true,                   // 明确启用自动播放
    disableOnInteraction: false      // 确保用户交互后自动播放继续
  },
  loop: true,                        // 启用循环模式
  loopAdditionalSlides: 2,           // 为循环模式添加更多额外幻灯片，确保2张图片也能循环
  // 移除可能导致警告的属性
  modules: [EffectCoverflow, Pagination, Autoplay], // 引入所需功能模块
  className: 'mySwiper',             // 自定义样式类名
  style: { height: '100%' },         // 高度100%，填充容器
  allowTouchMove: true,              // 允许触摸滑动
  // slideToClickedSlide: true,         // 点击幻灯片时切换到该幻灯片 - 已注释
  watchSlidesProgress: true,         // 监视幻灯片进度
  resistance: true,                  // 启用边缘阻力
  resistanceRatio: 0.85              // 阻力比率
};

// 名称样式配置
const NAME_STYLES = {
  textAlign: 'center',
  marginTop: '4px',
  color: '#aee2ff',
  fontSize: '14px',
  fontWeight: '600',
  textOverflow: 'ellipsis',
  overflow: 'hidden',
  whiteSpace: 'nowrap',
  width: '100%',
  textShadow: '0 0 10px rgba(174, 226, 255, 0.6)',
  background: 'linear-gradient(45deg, #aee2ff 0%, #7dd3fc 100%)',
  WebkitBackgroundClip: 'text',
  WebkitTextFillColor: 'transparent',
  backgroundClip: 'text'
};

// iframe样式配置
const IFRAME_STYLES = {
  width: '100%',
  height: '600px',
  border: 'none',
  borderRadius: '8px',
  boxShadow: '0 4px 20px rgba(0, 0, 0, )',
  backgroundColor: '#598097',
};

/**
 * Home720Page组件 - 720度全景展示轮播图组件
 * 功能：展示720度全景图片轮播，支持区域和机构筛选，点击弹出iframe显示pic360内容
 * @param {Object} props - 组件属性
 * @param {Array} props.imageList - 图片列表数据数组，若无则使用空数组
 */
const Home720Page = (props) => {
  const { videoList = [] } = props;

  // 日志记录，用于调试和监控

  return (
    <div style={{ height: '100%' }}>
      <div className="page-container"
        style={CONTAINER_STYLES}
      >

        {/* 半透明遮罩层：确保文字清晰可见 */}
        <div style={OVERLAY_STYLES} />
        {/* Swiper组件容器：设置为相对定位并置于最上层 */}
        <div style={SWIPER_CONTAINER_STYLES}>
          {/* Swiper轮播组件配置 */}
          <Swiper {...SWIPER_CONFIG}>
            {/* 渲染轮播图列表 */}
            {videoList.map((item, index) => {
              const uniqueKey = `item-${index}`;
              return (
                <SwiperSlide
                  key={uniqueKey}
                  style={SWIPER_SLIDE_STYLES}
                >
                  {/* 使用WrappedModal包装卡片，实现点击弹出Modal */}
                  <WrappedModal
                    className='modal-style-dark center-title-modal'
                    title={`${item.store_name}`}
                    
                    width={1000}
                    maskClosable={true}
                    baseComponent={
                      <>
                        <h2 style={{ textAlign: 'center', marginBottom: '16px', fontSize: '18px', fontWeight: 500, color: '#333333' }}>
                            ・{item.room_type_name}-{item.map_name}・
                          </h2>
                          <div
                            style={{
                              display: 'flex',
                              flexDirection: 'row',
                              width: '96%',
                              minHeight: '120px',
                              marginLeft: '2%',
                              padding: '8px',
                              backgroundColor: '#aee2ff',
                              borderRadius: '8px',
                              border: '2px solid #ffffff',
                              boxSizing: 'border-box'
                            }}
                          >
                            <video
                              src={item.video}
                              style={IFRAME_STYLES}
                              controls
                              playsInline
                            />
                          </div>                     
                      </>
         
                    }
                    onOk={() => {
                    }}
                    onCancel={() => {
                    }}
                  >
                  <Card
                      className="dbb-card-page swiper-card"
                    style={CARD_STYLES}
                  >
                      <div>
                        <img
                        src={item.defaultImg}
                        style={IMAGE_STYLES}
                        />
                        <div
                          style={NAME_STYLES}
                        >
                            {item.map_name}
                        </div>
                      </div>
                    
                    
                  </Card>
                  </WrappedModal>
                </SwiperSlide>
              )
            })}
            {/* 分页器容器 */}
            <div className="swiper-pagination"></div>
          </Swiper>
        </div>
      </div>
    </div>
  );
};

// 添加CSS样式
const styles = `
  .swiper-card {
    position: relative;
    overflow: hidden;
  }
  
  .swiper-card::before {
    content: '';
    position: absolute;
    top: 0;
    left: -100%;
    width: 100%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(33, 150, 243, 0.4), transparent);
    transition: left 0.6s ease;
    z-index: 1;
  }
  
  .swiper-card:hover::before {
    left: 100%;
  }
  
  .swiper-card:hover {
    transform: translateY(-3px);
    box-shadow: 0 8px 25px rgba(33, 150, 243, 0.3), 0 4px 12px rgba(33, 150, 243, 0.2);
    border-color: rgba(33, 150, 243, 0.6);
    background: linear-gradient(135deg, rgba(0, 20, 40, 0.98) 0%, rgba(0, 40, 80, 0.95) 100%);
  }
  
  .swiper-card > * {
    position: relative;
    z-index: 2;
  }
  
  @keyframes spin {
    0% { transform: translate(-50%, -50%) rotate(0deg); }
    100% { transform: translate(-50%, -50%) rotate(360deg); }
  }
  
  @keyframes monitor-glow {
    0%, 100% { 
      box-shadow: 0 0 15px rgba(33, 150, 243, 0.3), inset 0 0 10px rgba(33, 150, 243, 0.1);
    }
    50% { 
      box-shadow: 0 0 25px rgba(33, 150, 243, 0.5), inset 0 0 15px rgba(33, 150, 243, 0.2);
    }
  }
  
  .monitor-glow {
    animation: monitor-glow 3s ease-in-out infinite;
  }
`;

// 动态添加样式
if (typeof document !== 'undefined') {
  const styleSheet = document.createElement('style');
  styleSheet.textContent = styles;
  document.head.appendChild(styleSheet);
}

export default Home720Page;
